export class rgData extends HTMLScriptElement {

    constructor() {
        super();
        this.data = new Map();
    }

    connectedCallback() {
        if(!this.childElementCount) {
            const xmlDoc = new DOMParser().parseFromString(this.textContent, "text/html");
            this.textContent = '';
            xmlDoc.body.childNodes.forEach(function (node) {
                this.append(node);
            }.bind(this));
        }
        const config = {
            attributes: true,
            childList: true,
            subtree: true
        };
        const callback = function(mutationList, observer) {
            for (const mutation of mutationList) {
                document.dispatchEvent(new CustomEvent('rgdata:dataChanged', {
                    detail: {
                        el: this,
                        mutation: mutation
                    }
                }));
            }
        }.bind(this);

        const observer = new MutationObserver(callback);
        observer.observe(this, config);

        document.dispatchEvent(new CustomEvent('rgdata:dataAdded', {
            detail: {el: this}
        }));
    }

    disconnectedCallback() {
        document.dispatchEvent(new CustomEvent('rgdata:dataDeleted', {
            detail: {el: this}
        }));
    }
}